import { LitElement, html, Splide } from '@hh/global.js'

export class HHCartUpsell extends LitElement {
  static properties = {
    slider: { state: true },
  }

  constructor() {
    super()

    this.initSplide = this.initSplide.bind(this)
  }

  connectedCallback() {
    super.connectedCallback()
    setTimeout(this.initSplide, 500)
  }

  initSplide() {
    if (this.querySelector('.splide')) {
      this.initSlider()
    } else {
      setTimeout((this.initSplide, 500))
    }
  }

  initSlider() {
    const carouselEl = this.querySelector('.splide')
    if (!carouselEl) return

    this.slider = new Splide(carouselEl, {
      arrows: false,
      useScroll: true,
      pagination: false,
      fixedWidth: '84%',
      gap: '14px',
      autoplay: false,
    })

    this.slider.mount()
  }

  render() {
    return html`<slot></slot>`
  }
}

window.addEventListener('load', () => {
  customElements.define('hh-cart-upsell', HHCartUpsell)
})
